import { render, staticRenderFns } from "./DialogoManual.vue?vue&type=template&id=49e06195"
import script from "./DialogoManual.vue?vue&type=script&lang=ts"
export * from "./DialogoManual.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports